module.exports = __webpack_public_path__ + "static/media/piecedark.27b3735f.svg";